var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyBox = function SvgEmptyBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyBox_svg__a)",
    fillRule: "evenodd",
    d: "m9.283 14.25 14.44-2.583v14.655H9.283z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyBox_svg__b)",
    fillRule: "evenodd",
    d: "m23.723 11.67 17.456 2.362v13.371H23.723z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyBox_svg__c)",
    fillRule: "evenodd",
    d: "m9.283 14.247 16.81 3.531v20.824L9.283 34.11z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyBox_svg__d)",
    fillRule: "evenodd",
    d: "M9.499 17.813h16.594l-1.666 9.355L9.5 23.305z",
    clipRule: "evenodd",
    opacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyBox_svg__e)",
    fillRule: "evenodd",
    d: "m26.093 17.792 15.083-3.76v19.593L26.093 38.6z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyBox_svg__f)",
    fillRule: "evenodd",
    d: "M26.093 17.813h14.87v5.344l-13.491 4.995z",
    clipRule: "evenodd",
    opacity: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyBox_svg__g)",
    fillRule: "evenodd",
    d: "m9.282 14.247 16.81 3.546-3.342 7.666-16.917-4.361z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyBox_svg__h)",
    fillRule: "evenodd",
    d: "m26.093 17.792 15.083-3.76L44.4 20.8l-14.376 4.662z",
    clipRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#EmptyBox_svg__i)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M35.416 42.268c0 .69-4.663 1.25-10.416 1.25s-10.417-.56-10.417-1.25 4.664-.833 10.417-.833 10.416.143 10.416.833"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "EmptyBox_svg__a",
    x1: 3.542,
    x2: 64.899,
    y1: 3.333,
    y2: 39.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E1E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "EmptyBox_svg__b",
    x1: 3.333,
    x2: 33.559,
    y1: -5.833,
    y2: 36.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E1E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "EmptyBox_svg__c",
    x1: 5.833,
    x2: 25.417,
    y1: 88.333,
    y2: 1.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E1E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "EmptyBox_svg__d",
    x1: 17.939,
    x2: 17.939,
    y1: 26.468,
    y2: 18.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2C4CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "EmptyBox_svg__e",
    x1: 9.167,
    x2: 48.75,
    y1: 52.708,
    y2: 1.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E1E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "EmptyBox_svg__f",
    x1: 33.672,
    x2: 33.672,
    y1: 27.691,
    y2: 19.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2C4CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "EmptyBox_svg__g",
    x1: 6.875,
    x2: 15.617,
    y1: 162.5,
    y2: 15.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E1E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "EmptyBox_svg__h",
    x1: 27.034,
    x2: 37.082,
    y1: 165.183,
    y2: 15.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E1E5"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "EmptyBox_svg__i",
    width: 22.5,
    height: 3.75,
    x: 13.75,
    y: 40.602,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_1555_72",
    stdDeviation: 0.417
  })))));
};
export default SvgEmptyBox;